var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { RichH3, SpanText } from '../Typography';
import { isFieldValid } from '../../utils/validation';
import { Icon } from '../Icon';
import media from '../../utils/media';
import { UnstyledButton } from '../Buttons';
import { OnClickFocusWrapper } from '../UtilityWrappers';
const CategoryHeadingContainer = styled.div `
  width: calc(100% - 20px);
  min-height: 105px;
  border-bottom: 6px solid ${({ theme }) => theme.primaryBlack};
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0px 10px;
  background-color: ${({ theme }) => theme.primaryWhite};
  ${media.mobile} {
    min-height: 70px;
    margin: 0px;
    padding: 0px 10px;
    width: 100%;
  }

  button {
    background-color: ${({ theme }) => theme.primaryWhite};
  }
`;
const HeadingContainer = styled.div `
  width: 100%;
  max-width: 540px;
  min-height: 32px;
  display: flex;
  align-items: center;
`;
const ButtonContainer = styled(UnstyledButton) `
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0;
  border: none;
  max-width: 540px;
  width: 100%;
  cursor: pointer;
`;
const Label = styled(SpanText) `
  font-family: ${({ theme }) => theme.fontFamilyBold};
  letter-spacing: 0.005em;
  font-size: 16px;
  line-height: 20px;
`;
const StyledIcon = styled((_a) => {
    var { shouldImageFlip } = _a, others = __rest(_a, ["shouldImageFlip"]);
    return React.createElement(Icon, Object.assign({}, others));
}) `
  transform: ${({ shouldImageFlip }) => (shouldImageFlip ? 'scale(-1, -1)' : 'none')};
  color: ${({ theme }) => theme.primaryRed};
  font-size: 35px;
`;
export const CategoryHeader = ({ collapseText, expandText, questionCategoryTitle, openPanels, closePanels, isAllPanelsOpen, }) => {
    if (!isFieldValid(questionCategoryTitle)) {
        return null;
    }
    const label = isAllPanelsOpen ? collapseText.value : expandText.value;
    return (
    // className applied to apply box-shadow
    React.createElement(CategoryHeadingContainer, { className: "category-header" },
        isFieldValid(questionCategoryTitle) && (React.createElement(HeadingContainer, null,
            React.createElement(RichH3, { field: questionCategoryTitle }))),
        React.createElement(OnClickFocusWrapper, null,
            React.createElement(ButtonContainer, { onClick: isAllPanelsOpen ? closePanels : openPanels },
                React.createElement(Label, null, label),
                React.createElement(StyledIcon, { shouldImageFlip: isAllPanelsOpen }, "arrow_drop_down")))));
};
